<package-receive-progress></package-receive-progress>

<div class="steps-content">
  <p-card>
    <ng-template pTemplate="title">
      Package Receiving Complete
    </ng-template>
    <ng-template pTemplate="subtitle">
      Please follow the instructions below to complete the receiving process
    </ng-template>
    <ng-template pTemplate="content">
      <div class="row">
        <div class="col-3 h4">
        </div>
        <div class="col-6 h4">
          <div class="alert alert-success mt-4" role="alert" *ngIf="saveSuccessful && orderType == 1">
            Package successfully received and saved!  Please place the package in the <b>LabTek21</b> bin for processing.
          </div>
          <div class="alert alert-success mt-4" role="alert" *ngIf="saveSuccessful && orderType == 2">
            Package successfully received and saved!  Please place the package in the <b>LabTek21</b> bin for processing.
          </div>
          <div class="alert alert-success mt-4" role="alert" *ngIf="saveSuccessful && orderType == 3">
            Package successfully received and saved!  Please place the package in the <b>QuickBase</b> bin for processing.
          </div>
          <div class="alert alert-danger mt-4" role="alert" *ngIf="noClient">
            Package has been recorded but is not associated with a client.  Please place the package in the <b>Escalation</b> bin.
          </div>
        </div>
        <div class="col-3 h4">
        </div>
      </div>
    </ng-template>
    <ng-template pTemplate="footer">
      <div class="grid p-nogutter p-justify-end">
        <button class="navbutton" (click)="goAgain()" icon="pi pi-angle-right" iconPos="right">Receive Another Package</button>
      </div>
    </ng-template>
  </p-card>
</div>
<p-toast>
</p-toast>
